<script>
  import Grid from './grid'

  export default Grid('layout')
</script>

<style lang="stylus" src="../../stylus/components/_grid.styl"></style>



// WEBPACK FOOTER //
// src/components/VGrid/VLayout.vue?d00ebc5c